<template>
    <div class="container mx-auto">
        <div class="row justify-content-center">
            <div class="col-md-8">
                <div class="card">
                    <div class="card-header">{{ _page.title }}</div>
                    <div class="card-body" v-html="_page.content"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: [ 'page' ],

        computed: {
            _page () {
                return JSON.parse(this.page)
            }
        },

        mounted() {
        }
    }
</script>

<style lang="scss" scoped>

</style>
